// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"595a92c4","174":"6a5e5746","516":"2d187e38","601":"7c3bd2ed","727":"f44afd06"}[chunkId] + ".chunk.js";
};